import MaterialReactTable from "material-react-table";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import { fetchProduitFour } from "../../../Redux/produitReduce";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-multi-lang';
import { verification } from "../../../Redux/usersReduce";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useParams, useHistory } from "react-router-dom";
// core components
function ListProduitFourV({ client }) {
  const dispatch = useDispatch();
  const t = useTranslation();
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);

  const navigate = useHistory();
  // Add this function inside your component
const exportToExcel = async () => {
  if (!entities || entities.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Produits");

  // Colonnes dynamiques basées sur les clés du premier objet
  worksheet.columns = Object.keys(entities[0]).map((key) => ({
    header: key,
    key: key,
    width: 20,
  }));

  // Style header
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
  headerRow.alignment = { horizontal: "center" };
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF3285C6" }, // couleur propre
    };
  });

  // Ajouter données
  entities.forEach((item) => {
    worksheet.addRow(item);
  });

  // Freeze header
  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  // AutoFilter
  worksheet.autoFilter = {
    from: "A1",
    to: String.fromCharCode(64 + Object.keys(entities[0]).length) + "1",
  };

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "produits.xlsx");
};

  const getProduit = useCallback(async (titre) => {
    var marche = await dispatch(fetchProduitFour({ client }));
    setEntities(marche.payload);
    setLoader(false)
  }, [dispatch]);

  const [columns] = React.useState([
    {
      header: "designation",
      accessorKey: "designation",
    },
    {
      header: "code",
      accessorKey: "code",
    },
    {
      header: "code Article",
      accessorKey: "code_article",
    },
    {
      header: "designation Parent",
      accessorKey: "designation_parent",
    },
    {
      header: "Nom user",
      accessorKey: "nom_user",
    },
    {
      header: "actions",
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          <Button
            onClick={() => {
              navigate.push(client + "/produitParent/update/" + cell.row.original.id);
            }}
            variant="warning"
            size="sm"
            className="text-warning btn-link edit"
          >
            Modifier parent <i className="fa fa-edit" />
          </Button>
        </div>
      ),
    },
  ])
  function ListTable({ list, loader }) {
    return (
      <div>
        {loader ? (
          <div className="text-center">
            <img
              src={require("../../../assets/img/loader.gif")}
              alt="loader"
              className="loader-img"
            />
          </div>
        ) : (
          <MaterialReactTable
            columns={columns}
            data={list}
            enableColumnActions={true}
            enableColumnFilters={true}
            enablePagination={true}
            enableSorting={true}
            enableBottomToolbar={true}
            enableTopToolbar={true}
            muiTableBodyRowProps={{ hover: false }}
            displayColumnDefOptions={{
              'mrt-row-numbers': {
                size: 10,
              },
              'mrt-row-expand': {
                size: 10,
              },
            }}
            enableColumnFilterModes
            initialState={{
              columnVisibility: { description: false },
              density: 'compact',
              showGlobalFilter: true,
            }}
            muiSearchTextFieldProps={{
              placeholder: t("search"),
              sx: { minWidth: '18rem' },
              variant: 'outlined',
            }}
          />
        )}
      </div>
    );
  }

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getProduit()
  }, [getProduit]) //now shut up eslint
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
          </Col>
          <Col md="12">

            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("Produit.list")}</Card.Title>
                <Button  onClick={exportToExcel} className="mb-3 btn-export">
                   <i class="fa-solid fa-file-excel"></i> Export Excel
                </Button>
              </Card.Header>
              <Card.Body>
                <ListTable list={entities} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListProduitFourV;
